import React from 'react';
import { Stack, Text } from '@moda/om';
import { useCart } from '../../../hooks/useCart';
import { AffirmPromoMessage } from '../../AffirmPromoMessage';

export const CheckoutAffirmPaymentMethod: React.FC = () => {
  const {
    cart: {
      attributes: {
        paymentSummary: { payToday }
      }
    }
  } = useCart();

  return (
    <Stack space={3}>
      <AffirmPromoMessage pageType="cart" price={Number(payToday.price)} />
      <Text>
        After clicking PLACE YOUR ORDER, you will be directed to Affirm's site to select a financing
        plan and complete your purchase securely.
      </Text>
    </Stack>
  );
};
